export default "__VITE_ASSET__Cncyb0$P__"